import { Component, Inject, OnInit, ViewChild, forwardRef } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { Thing } from "../../model";
import { DataSharingTokenService } from "../../service/data-sharing-token.service";
import { UserThingService } from "../../service/user-thing.service";
import { ErrorUtility } from "../../utility/error-utility";

@Component({
    selector: 'add-data-sharing-token-dialog',
    template: require('./add-data-sharing-token-dialog.component.html'),
})
export class AddDataSharingTokenDialogComponent implements OnInit {

    @ViewChild('form') form: NgForm;

    error: string;
    things: Thing[];
    loaded: boolean;

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) private dialogRef: MatDialogRef<AddDataSharingTokenDialogComponent>,
        @Inject(forwardRef(() => UserThingService)) private userThingService: UserThingService,
        @Inject(forwardRef(() => DataSharingTokenService)) private dataSharingTokenService: DataSharingTokenService,
    ) { }

    ngOnInit(): void {
        this.userThingService.getRecursivelyAllThings(0, [], null, null, null, null, null, true).then(things => {
            this.things = things;
            this.loaded = true;
        }).catch(err => {
            this.error = ErrorUtility.getMessage(err);
            this.loaded = true;
        });
    }

    save(): void {
        const body = this.form.form.getRawValue();
        this.dataSharingTokenService.save(body).then(token => this.dialogRef.close(token)).catch(err => this.error = ErrorUtility.getMessage(err));
    }

}